import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl23FormDataToModel,
  convertModelToBefehl23FormData
} from './converters'
import Auftrag23_10Form from './Auftrag23_10Form'
import { useBefehlForm } from '../../../hooks'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl23 } from '../../../models'
import { Befehl23FormData, createBefehl23FormValidationSchema } from './schema'

/**
 * Main form component for Befehl 23
 */

export default function Befehl23Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-23-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl23>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl23FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl23FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl23FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl23FormData) => {
      const updatedBefehl = convertBefehl23FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl23FormData>
      befehlKennung="23"
      title={t('befehle.23.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 23.10 */}
      <Auftrag23_10Form
        befehlKennung="23"
        fieldPrefix="auftrag_23_10"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-23-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
